exports.FaDirective = require('./lib/directives/fa.directive').FaDirective;
//exports.FaStackDirective = require('./lib/directives/fa-stack.directive').FaStackDirective;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2-fontawesome/directives.js
 ** module id = 933
 ** module chunks = 0
 **/